import type { Components, Theme } from '@mui/material/styles';

export const components: Components<Omit<Theme, 'components'>> = {
  // Add dir="auto" to all input components for automatic text direction detection
  MuiTextField: {
    defaultProps: {
      inputProps: {
        dir: 'auto',
      },
    },
  },
  MuiOutlinedInput: {
    defaultProps: {
      inputProps: {
        dir: 'auto',
      },
    },
  },
  MuiInput: {
    defaultProps: {
      inputProps: {
        dir: 'auto',
      },
    },
  },
  MuiFilledInput: {
    defaultProps: {
      inputProps: {
        dir: 'auto',
      },
    },
  },
  MuiInputBase: {
    defaultProps: {
      inputProps: {
        dir: 'auto',
      },
    },
  },
  MuiSelect: {
    defaultProps: {
      inputProps: {
        dir: 'auto',
      },
    },
  },
  // Note: MuiAutocomplete requires custom handling in individual components
  // Button component overrides
  // MuiButton: {
  //   styleOverrides: {
  //     root: {
  //       textTransform: 'none',
  //       borderRadius: 8,
  //       fontWeight: 500,
  //       padding: '8px 16px',
  //       boxShadow: 'none',
  //       '&:hover': {
  //         boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
  //       },
  //     },
  //     contained: {
  //       '&:hover': {
  //         boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.15)',
  //       },
  //     },
  //     outlined: {
  //       borderWidth: '1.5px',
  //       '&:hover': {
  //         borderWidth: '1.5px',
  //       },
  //     },
  //   },
  // },
  // // Card component overrides
  // MuiCard: {
  //   styleOverrides: {
  //     root: {
  //       borderRadius: 12,
  //       boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.08)',
  //       '&:hover': {
  //         boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.12)',
  //       },
  //     },
  //   },
  // },
  // // Paper component overrides
  // MuiPaper: {
  //   styleOverrides: {
  //     root: {
  //       borderRadius: 8,
  //     },
  //     elevation1: {
  //       boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.08)',
  //     },
  //     elevation2: {
  //       boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.12)',
  //     },
  //     elevation3: {
  //       boxShadow: '0px 6px 12px rgba(0, 0, 0, 0.15)',
  //     },
  //   },
  // },
  // // TextField component overrides
  // MuiTextField: {
  //   styleOverrides: {
  //     root: {
  //       '& .MuiOutlinedInput-root': {
  //         borderRadius: 8,
  //         '&:hover .MuiOutlinedInput-notchedOutline': {
  //           borderWidth: '2px',
  //         },
  //         '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
  //           borderWidth: '2px',
  //         },
  //       },
  //     },
  //   },
  // },
  // // Chip component overrides
  // MuiChip: {
  //   styleOverrides: {
  //     root: {
  //       borderRadius: 16,
  //       fontWeight: 500,
  //     },
  //   },
  // },
  // // AppBar component overrides
  // MuiAppBar: {
  //   styleOverrides: {
  //     root: {
  //       boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)',
  //     },
  //   },
  // },
  // // Drawer component overrides
  // MuiDrawer: {
  //   styleOverrides: {
  //     paper: {
  //       borderRadius: 0,
  //       borderRight: '1px solid rgba(0, 0, 0, 0.12)',
  //     },
  //   },
  // },
  // // Dialog component overrides
  // MuiDialog: {
  //   styleOverrides: {
  //     paper: {
  //       borderRadius: 12,
  //       boxShadow: '0px 8px 32px rgba(0, 0, 0, 0.2)',
  //     },
  //   },
  // },
  // // Menu component overrides
  // MuiMenu: {
  //   styleOverrides: {
  //     paper: {
  //       borderRadius: 8,
  //       boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.15)',
  //       marginTop: 4,
  //     },
  //   },
  // },
  // // MenuItem component overrides
  // MuiMenuItem: {
  //   styleOverrides: {
  //     root: {
  //       borderRadius: 4,
  //       margin: '2px 8px',
  //       '&:hover': {
  //         borderRadius: 4,
  //       },
  //     },
  //   },
  // },
  // // Tab component overrides
  // MuiTab: {
  //   styleOverrides: {
  //     root: {
  //       textTransform: 'none',
  //       fontWeight: 500,
  //       minHeight: 48,
  //     },
  //   },
  // },
  // // Tooltip component overrides
  // MuiTooltip: {
  //   styleOverrides: {
  //     tooltip: {
  //       borderRadius: 6,
  //       fontSize: '0.75rem',
  //       fontWeight: 500,
  //     },
  //   },
  // },
  // // IconButton component overrides
  // MuiIconButton: {
  //   styleOverrides: {
  //     root: {
  //       borderRadius: 8,
  //       '&:hover': {
  //         backgroundColor: 'rgba(0, 0, 0, 0.04)',
  //       },
  //     },
  //   },
  // },
  // // FormControl component overrides
  // MuiFormControl: {
  //   styleOverrides: {
  //     root: {
  //       marginBottom: 16,
  //     },
  //   },
  // },
  // // FormLabel component overrides
  // MuiFormLabel: {
  //   styleOverrides: {
  //     root: {
  //       fontWeight: 500,
  //       marginBottom: 8,
  //     },
  //   },
  // },
};
